import { Base_Url } from "../../BaseURL/BaseUrl";
import {
    getListWithAuthenticated,
    postApiWithAuthenticated,
} from "../ApiMethods/ApiMethod";

const BaseUrl = `${Base_Url}/RoleType`;

export const GetRoleTypeList = async (params) => {

    let url = `${BaseUrl}/GetRoleTypeList`;
    const res = await postApiWithAuthenticated(url, params);
    return res;
};
export const ChangeRoleTypeStatus = async (UserKeyID, RoleTypeID) => {

    let url = `${BaseUrl}/ChangeRoleTypeStatus?UserKeyID=${UserKeyID}&RoleTypeID=${RoleTypeID}`;
    const res = await getListWithAuthenticated(url);
    return res;
};